import {ISentLeadStoredValues} from "../../types/lead/ISentLeadStoredValues";

export const emptyLeadStorageData: ISentLeadStoredValues = {
    email: "",
    name: "",
    phone: "",
    rooms: [],
    text: "",
    marketing_email: false,
    marketing_sms: false
};
